export default function makePhoneCall(number) {
  window.open(`tel:${number}`);
}